"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _formFields = require("@trodly/form-fields");

require("react-dates/initialize");

require("react-dates/lib/css/_datepicker.css");

var _reactDates = require("react-dates");

var _moment = _interopRequireDefault(require("moment"));

var _baseModule = _interopRequireDefault(require("./styles/base.module.css"));

require("./styles/react_dates_overrides.css");

var _actions = require("../actions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DateSelection =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DateSelection, _React$Component);

  function DateSelection(props) {
    var _this;

    _classCallCheck(this, DateSelection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateSelection).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "setDateSelected", function (startDate, endDate) {
      _this.setState({
        startDate: startDate,
        endDate: endDate
      });

      var setDate = _this.props.setDate;
      var dateType = endDate ? "flexible" : "fixed";

      if (endDate) {
        setDate({
          dateType: dateType,
          startDate: (0, _moment.default)(startDate).unix(),
          endDate: (0, _moment.default)(endDate).unix()
        });
      } else {
        setDate({
          dateType: dateType,
          startDate: (0, _moment.default)(startDate).unix(),
          endDate: null
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "dateType", function (checked) {
      _this.setState({
        dateRange: checked
      });
    });

    _this.state = {
      dateRange: props.date.dateType === "flexible",
      startDate: props.date.startDate ? _moment.default.unix(props.date.startDate) : null,
      endDate: props.date.endDate ? _moment.default.unix(props.date.endDate) : null,
      focused: null,
      focusedInput: null
    };
    return _this;
  }

  _createClass(DateSelection, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          dateRange = _this$state.dateRange,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate,
          focused = _this$state.focused,
          focusedInput = _this$state.focusedInput;
      return _react.default.createElement("div", {
        className: _baseModule.default.container,
        style: {
          marginTop: "1.25rem"
        }
      }, _react.default.createElement("div", {
        className: "".concat(_baseModule.default.displayFlex, " ").concat(_baseModule.default.justifyContentBetween)
      }, _react.default.createElement("div", {
        className: _baseModule.default.label
      }, "When?"), _react.default.createElement("div", {
        className: "".concat(_baseModule.default.displayFlex, " ").concat(_baseModule.default.alignItemsCenter)
      }, _react.default.createElement(_formFields.CheckBox, {
        name: "dateType",
        value: "dateType",
        onChange: this.dateType,
        label: "My dates are flexible",
        className: _baseModule.default.dateSelectionCheckBox,
        checked: dateRange
      }))), _react.default.createElement("div", {
        className: _baseModule.default.container
      }, dateRange ? _react.default.createElement(_reactDates.DateRangePicker, {
        startDateId: "startDate",
        endDateId: "endDate",
        required: true,
        startDate: startDate,
        endDate: endDate,
        onDatesChange: function onDatesChange(_ref) {
          var startDate = _ref.startDate,
              endDate = _ref.endDate;

          _this2.setDateSelected(startDate, endDate);
        },
        focusedInput: focusedInput,
        onFocusChange: function onFocusChange(focusedInput) {
          _this2.setState({
            focusedInput: focusedInput
          });
        },
        displayFormat: "DD/MM/YYYY",
        block: true,
        numberOfMonths: 1,
        noBorder: true
      }) : _react.default.createElement(_reactDates.SingleDatePicker, {
        placeholder: "Select date",
        date: startDate,
        onDateChange: function onDateChange(date) {
          return _this2.setDateSelected(date);
        },
        focused: focused,
        onFocusChange: function onFocusChange(_ref2) {
          var focused = _ref2.focused;
          return _this2.setState({
            focused: focused
          });
        },
        displayFormat: "DD/MM/YYYY",
        block: true,
        required: true,
        numberOfMonths: 1,
        noBorder: true
      })));
    }
  }]);

  return DateSelection;
}(_react.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    date: state.date
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setDate: function setDate(date) {
      return dispatch((0, _actions.setDate)(date));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DateSelection);

exports.default = _default;